export default function PHP_preg_last_error() {
  return (
    <div>
      <h1>PHP_preg_last_error</h1>
    </div>
  );
}
